<template>
    <section class="order-update container-fluid background-white text-black">
        <article class="row">
            <div class="col-md-12">
                <order-header title="Order Returns & Refunds"/>
            </div>
        </article>
        <article class="row">
            <div class="col-md-12">
                <order-id v-on:fetchOrder="fetchData"
                          :region.sync="regionModel"
                          :orderPo.sync="orderPo"
                          :orderNum="orderNum"
                          :d365Id="d365Id"
                          :disabled="isPreloaded"
                          :isLoading="isLoading"
                          :hideButton = "hideButton"/>
            </div>
        </article>
        <hr>
        <article class="row">
            <div class="col-md-12">
                <router-view/>
            </div>
        </article>

        <LockedDialog :lockKey="lockKey" />
    </section>
</template>

<script>
  import {mapActions, mapGetters, mapState, mapMutations} from 'vuex';
  import OrderId from '../Shared/OrderId';
  import OrderHeader from '../Shared/OrderHeader';
  import LockedDialog from '../Shared/LockedDialog';
  import OrderReturnUpdatePage from './OrderReturnUpdatePage';
  import { keyify, hasLock } from '../../../store/modules/locks';
  import {
    ORDER_RETURN_INIT, ORDER_RETURN_RESET,
    ORDER_RETURN_SET_REGION,
  } from '../../../store/modules/order/return/types';

  export default {
    name: 'OrderReturnPageWrapper',
    components: {
      LockedDialog,
      OrderReturnUpdatePage,
      OrderHeader,
      OrderId,
    },
    computed: {
      ...mapState({
        storeState: state => state.orderReturn.state,
        isLoading: state => state.orderReturn.loading,
        region: state => state.orderReturn.region,
        orderNum: state => state.orderReturn.order ? state.orderReturn.order.name : null,
        d365Id: state => state.orderReturn.order ? state.orderReturn.order.d365_id : null,
        hideButton: state =>state.orderReturn.hideButton?state.orderReturn.hideButton:false,
      }),
      regionModel: {
        get() {
          return this.region;
        },
        set(value) {
          this.setRegion(value);
        },
      },
      lockKey() {
        if (!this.region || !this.orderPo) {
          return '';
        }

        return keyify([this.region, this.orderPo]);
      },
    },
    methods: {
      ...mapMutations({
        setRegion: ORDER_RETURN_SET_REGION,
      }),
      ...mapActions({
        orderInit: ORDER_RETURN_INIT,
        reset: ORDER_RETURN_RESET
      }),
      normalizeRouteValue(value) {
        return Array.isArray(value) ? value[0] : value;
      },
      getPreloadedOrder() {
        const orderRegion = this.normalizeRouteValue(this.$route.params.region) ||
            this.normalizeRouteValue(this.$route.query.region);
        const orderId = this.normalizeRouteValue(this.$route.params.id) ||
            this.normalizeRouteValue(this.$route.query.orderPo);

        if (!orderRegion || !orderId) {
          return null;
        }

        return {
          orderId,
          orderRegion: orderRegion.toLowerCase(),
        };
      },
      fetchData() {
        this.orderInit({orderId: this.orderPo});
      },
    },
    data() {
      return {
        orderPo: null,
        isPreloaded: false,
      };
    },
    created() {
      const preloadedOrder = this.getPreloadedOrder();

      if (!preloadedOrder) {
        return;
      }

      const {orderId, orderRegion} = preloadedOrder;

      this.isPreloaded = true;
      this.orderPo = orderId;
      this.regionModel = orderRegion;
      this.fetchData();
    },
    beforeRouteLeave(to, from, next) {
      this.reset();
      next();
    }
  };
</script>
